import { render, staticRenderFns } from "./orderDetailgo.vue?vue&type=template&id=b02c9374&scoped=true"
import script from "./orderDetailgo.vue?vue&type=script&lang=ts"
export * from "./orderDetailgo.vue?vue&type=script&lang=ts"
import style0 from "./orderDetailgo.vue?vue&type=style&index=0&id=b02c9374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02c9374",
  null
  
)

export default component.exports